export const injectionKeyIsVerticalNavHovered: InjectionKey<Ref<boolean>>
  = Symbol('isVerticalNavHovered')
